// extracted by mini-css-extract-plugin
export default {"save_btn":"styles_save_btn__m+jZ3","cancel_btn":"styles_cancel_btn__etAQM","btn_container":"styles_btn_container__J34MH"};